import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import NavbarMob from "../components/NavbarMob";
import Navbar from "../components/Navbar";
import Navbar2 from "../components/Navbar2";
import Footer from "../components/Footer";
import call from "../images/contactus/call.png";
import email from "../images/contactus/email.png";
import location from "../images/contactus/location.png";
import twitter from "../images/contactus/twitter.png";
import insta from "../images/contactus/insta.png";
import arrow from "../images/contactus/arrow.png";
import Navbar2Mob from "../components/Navbar2Mob";

function ContactUs() {
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const [phoneNumber, setPhoneNumber] = useState("");
    const [newPhoneNumber, setNewPhoneNumber] = useState("");
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const customerType = sessionStorage.getItem("customerType");

    const [locations, setLocations] = useState([]);
    const [newLocation, setNewLocation] = useState("");
    const [editingIndex, setEditingIndex] = useState(null);
    const [editValue, setEditValue] = useState("");

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobileNumber: "",
        message: "",
    });

    useEffect(() => {
        fetch("/json/contactpage.json")
            .then((res) => res.json())
            .then((data) => {
                const saved = localStorage.getItem("contactus-locations");
                setLocations(saved ? JSON.parse(saved) : data.locations || []);
            });
    }, []);

    useEffect(() => {
        if (locations.length > 0) {
            localStorage.setItem("contactus-locations", JSON.stringify(locations));
        }
    }, [locations]);

    const startEdit = (index) => {
        setEditingIndex(index);
        setEditValue(locations[index]);
    };

    const cancelEdit = () => {
        setEditingIndex(null);
        setEditValue("");
    };

    useEffect(() => {
        fetch(`${apiBaseUrl}/locations`)
            .then((res) => res.json())
            .then((data) => setLocations(data));
    }, [apiBaseUrl]);

    const addLocation = async () => {
        await fetch(`${apiBaseUrl}/locations`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ location: newLocation }),
        });

        setNewLocation("");
        refreshLocations();
    };

    const saveEdit = async () => {
        await fetch(`${apiBaseUrl}/locations/${editingIndex}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ value: editValue }),
        });

        setEditingIndex(null);
        setEditValue("");
        refreshLocations();
    };

    const deleteLocation = async (index) => {
        await fetch(`${apiBaseUrl}/locations/${index}`, {
            method: "DELETE",
        });

        refreshLocations();
    };

    const refreshLocations = () => {
        fetch(`${apiBaseUrl}/locations`)
            .then((res) => res.json())
            .then((data) => setLocations(data));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    useEffect(() => {
        // Fetch the saved phone number from the backend when the component mounts
        fetch(`${apiBaseUrl}/getPhoneNumber`)
            .then((response) => response.json())
            .then((data) => {
                // Assuming the response is an array with an object containing phoneNumber
                setPhoneNumber(data[0].phoneNumber); // Access the first element and its phoneNumber property
            })
            .catch((error) => console.log(error));
    }, [apiBaseUrl]);

    const handlePhoneChange = (e) => {
        setNewPhoneNumber(e.target.value);
    };

    const handleUpdatePhoneNumber = () => {
        // Send the new phone number to the backend to be saved in the database
        fetch(`${apiBaseUrl}/updatePhoneNumber`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ phoneNumber: newPhoneNumber }),
        })
            .then((response) => response.text()) // We expect a text response
            .then((data) => {
                if (data === "Phone number updated successfully") {
                    setPhoneNumber(newPhoneNumber); // Update the phone number on success
                    setNewPhoneNumber(""); // Clear the input field
                }
            })
            .catch((error) => console.log(error));
    };

    const handleSendToWhatsApp = async () => {
        // console.log("handleSendToWhatsApp called");
        const { name, email, mobileNumber, message } = formData;

        // Validate inputs
        if (!name.trim()) {
            alert("Please enter your Name.");
            return;
        }

        // Validate Mobile Number
        if (!mobileNumber.trim()) {
            alert("Please enter your Mobile Number.");
            return;
        }

        const cleanedNumber = mobileNumber.replace(/\D/g, "");

        // if (cleanedNumber.length === 0) {
        //     alert("Please enter your Mobile Number.");
        //     return;
        // }

        if (cleanedNumber.length !== 10) {
            alert("Please enter a valid 10-digit mobile number.");
            return;
        }

        if (!/^[6-9]\d{9}$/.test(cleanedNumber)) {
            alert("Please enter a valid Indian mobile number");
            return;
        }
        // Validate Message
        if (!message.trim()) {
            alert("Please enter your Message.");
            return;
        }

        setLoading(true);

        // Prepare data for WhatsApp API
        const to = "919544500746"; // Assuming Indian country code
        const formattedMessage = `*New Contact Inquiry* \n\nName: ${name}\nNumber: ${mobileNumber}\nEmail: ${email}\nMessage: ${message}`;

        try {
            const response = await fetch(`${apiBaseUrl}/send-whatsapp-contactus`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ to, message: formattedMessage }),
            });

            const data = await response.json();
            if (data.success) {
                alert("Message sent successfully to WhatsApp!");
                setFormData({
                    name: "",
                    email: "",
                    mobileNumber: "",
                    message: "",
                });
            } else {
                alert("Something went wrong. Please try again.");
            }
        } catch (error) {
            console.error("Error sending WhatsApp message:", error);
            alert("An error occurred while sending the message. Please try again.");
        }
        setLoading(false);
    };

    return (
        <div className="min-h-screen flex flex-col">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="md:flex hidden">
                <Navbar2 />
            </div>
            <div className="md:hidden flex flex-col">
                <Navbar2Mob />
            </div>

            <div className="lg:px-12 px-3 w-full gap-12 mt-6 flex flex-col ">
                <div className="w-full gap-3 flex flex-col">
                    <span className="lg:text-3xl text-2xl font-[700] font-display text-[#E22E37]">Contact Us</span>
                    <span className="lg:text-lg text-base font-[500] font-display">
                        Any question or remarks? Just write us a message!
                    </span>
                </div>
                <div className="w-full flex lg:flex-row flex-col gap-3  h-auto">
                    <div className="lg:w-[40%] w-[100%] h-fit  bg-[#E22E37] lg:p-12 p-3  flex flex-col items-start text-left rounded-[10px]  justify-center gap-4">
                        <div className="flex flex-col gap-2">
                            <span className="lg:text-2xl text-xl font-[600] font-display  text-white">
                                Contact Information
                            </span>
                            <span className="lg:text-lg text-base font-[400] font-display  text-[#C9C9C9]">
                                Say something to start a live chat!
                            </span>
                        </div>

                        <div className="flex flex-col gap-4">
                            <div className="flex flex-row gap-3">
                                <img src={call} alt="call" />
                                <span className="lg:text-base text-sm font-[400] font-display text-[white]">
                                    +91 {phoneNumber}
                                </span>
                            </div>
                            {customerType === "mainAdmin" && (
                                <div className="flex flex-row gap-4 items-center">
                                    <input
                                        type="text"
                                        value={newPhoneNumber}
                                        onChange={handlePhoneChange}
                                        placeholder="Enter New Phone Number"
                                        className="w-full max-w-md p-2 border-2 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-400"
                                    />
                                    <button
                                        onClick={handleUpdatePhoneNumber}
                                        className="w-full max-w-md p-2 bg-[#191975] text-white rounded-md text-lg font-semibold hover:bg-[blue] focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                        Update Number
                                    </button>
                                </div>
                            )}

                            <div className="flex flex-row gap-3">
                                <img src={email} alt="call" />
                                <span className="lg:text-base text-sm font-[400] font-display text-[white]">
                                    riyahub4u@gmail.com
                                </span>
                            </div>

                            <div className="flex gap-4 ">
                                <div className="flex-shrink-0">
                                    <img src={location} alt="location"  />
                                </div>

                                {/* SHOW LOCATIONS IN ONE LINE */}
                                <div className="flex flex-wrap items-center lg:text-base text-sm font-[400] font-display text-white">
                                    {locations.map((loc, i) => (
                                        <span key={i} className="flex items-center">
                                            {/* Editing mode */}
                                            {editingIndex === i ? (
                                                <>
                                                    <input
                                                        value={editValue}
                                                        onChange={(e) => setEditValue(e.target.value)}
                                                        className="px-2 py-1 text-black rounded text-sm"
                                                        autoFocus
                                                    />
                                                    <button onClick={saveEdit} className="text-green-300 text-xs ml-2">
                                                        Save
                                                    </button>
                                                    <button onClick={cancelEdit} className="text-gray-400 text-xs ml-2">
                                                        Cancel
                                                    </button>
                                                </>
                                            ) : (
                                                <>
                                                    <span className="-ml-2">{loc}</span>

                                                    {/* Admin edit/delete */}
                                                    {customerType === "mainAdmin" && (
                                                        <>
                                                            <button
                                                                onClick={() => startEdit(i)}
                                                                className="text-blue-800 text-xs ml-2"
                                                            >
                                                                Edit
                                                            </button>
                                                            <button
                                                                onClick={() => deleteLocation(i)}
                                                                className="text-red-300 text-xs ml-2"
                                                            >
                                                                Delete
                                                            </button>
                                                        </>
                                                    )}
                                                </>
                                            )}

                                            {/* Add comma (only if NOT last item) */}
                                            {i < locations.length - 1 && <span>,&nbsp;&nbsp;&nbsp;</span>}
                                        </span>
                                    ))}

                                    {/* Add new location (ADMIN ONLY) */}
                                    {customerType === "mainAdmin" && (
                                        <div className="flex gap-2 ml-3">
                                            <input
                                                type="text"
                                                value={newLocation}
                                                onChange={(e) => setNewLocation(e.target.value)}
                                                onKeyPress={(e) => e.key === "Enter" && addLocation()}
                                                placeholder="Add location"
                                                className="px-3 py-1 text-black text-sm rounded"
                                            />
                                            <button
                                                onClick={addLocation}
                                                className="px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700 text-sm"
                                            >
                                                Add
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* <div className="flex flex-row gap-3">
                                <img className="h-[50%]" src={location} alt="call" />
                                <span className="lg:text-base text-sm font-[400] font-display text-[white]">
                                    Perinthalmanna, Mannarkad, Ernakulam, Pattambi, Melattur, Cherupullasery
                                </span>
                            </div> */}
                        </div>
                        <div className="flex flex-col gap-6">
                            <div className="flex flex-row gap-3">
                                <div className="w-[30px] h-[30px] rounded-full bg-[white] flex justify-center items-center">
                                    <img src={twitter} alt="twitter" />
                                </div>
                                <div className="w-[30px] h-[30px] rounded-full bg-[white] flex justify-center items-center">
                                    <img src={insta} alt="insta" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-[60%]  w-[100%]  h-full  lg:p-12 p-3  flex flex-col items-start text-left rounded-[10px] gap-12">
                        <div className="w-full flex flex-row gap-3">
                            <div className="flex flex-col w-[100%] gap-6">
                                <span className="lg:text-lg text-base font-[500] font-display">Full Name</span>
                                <input
                                    placeholder="Enter Your Name "
                                    type="text"
                                    className="w-full border-b-2 border-[#8D8D8D] focus:outline-none focus:ring-0"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="w-full flex flex-row gap-3">
                            <div className="flex flex-col w-[50%] gap-6">
                                <span className="lg:text-lg text-base font-[500] font-display">Email</span>
                                <input
                                    type="text"
                                    placeholder="Enter Your Mail"
                                    className="w-full border-b-2 border-[#8D8D8D] focus:outline-none focus:ring-0"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="flex flex-col w-[50%] gap-6">
                                <span className="lg:text-lg text-base font-[500] font-display">Phone Number</span>
                                <input
                                    type="text"
                                    placeholder="Enter Phone Number"
                                    className="w-full border-b-2 border-[#8D8D8D] focus:outline-none focus:ring-0"
                                    name="mobileNumber"
                                    value={formData.mobileNumber}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="w-full flex flex-row gap-3">
                            <div className="flex flex-col w-[100%] gap-6">
                                <span className="lg:text-lg text-base font-[500] font-display">Message</span>
                                <input
                                    placeholder="write your message"
                                    type="text"
                                    className="w-full border-b-2 border-[#8D8D8D] focus:outline-none focus:ring-0"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="w-full flex flex-col">
                            <div className="flex w-full justify-end items-end">
                                <div className="h-[50px] lg:w-[20%] w-[50%] bg-[#E22E37] rounded-[10px] flex flex-end text-[white] justify-center items-center lg:text-xl text-base font-[500] font-display cursor-pointer hover:bg-[black]">
                                    {loading ? (
                                        <div className="w-5 h-5 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#E22E37]"></div>
                                    ) : (
                                        <span onClick={handleSendToWhatsApp}>Send</span>
                                    )}
                                </div>
                            </div>
                            <div className="flex w-full h-[120px]  justify-center items-center">
                                <div className="h-full w-[40%] ">
                                    <img src={arrow} alt="arrow" className="w-full h-full" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-12">
                <Footer />
            </div>
        </div>
    );
}

export default ContactUs;
